import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

export default function Grid ({ data, currentQuestion, responses, setResponses, grid, setGrid }) {
	const { t } = useTranslation('survey');

	// The grid handler called onChange on the radios
	const errorSelector = 'q' + [currentQuestion + 1] + 'error';
	const gridHandler = (event) => {
		// Get the selected values
		let value = event.target.value;
		let name = event.target.name;
		let type = event.target.type;
		let currentID = name.toLowerCase().replace(/\s/g, '-').replace(/\W/g, '-') + 'error';
		// Get, and update the array of selected
		let values = grid;
		values[name] = event.target.value;
		// Update any error checking, selecting will always remove any errors as it's a radio.
		if (document.querySelector('#' + currentID)) {
			document.querySelector('#' + currentID).classList.remove('grid-error');
			document.querySelector('#' + currentID).removeAttribute('aria-invalid');
			document.querySelector('#' + currentID).removeAttribute('aria-describedby');
			// Hide the error that appears on pressing next if all the errors are cleared on typing
			if (!document.querySelector('.grid-error')) {
				// Move the p back into the wrapper
				document.querySelector('#' + errorSelector).parentNode.append(document.querySelector('#' + errorSelector + '-content'));
			}
		}
		// Set the grid variable
		setGrid({ ...values });
	};

	// Update the responses array.
	useEffect(() => {
		responses[currentQuestion] = grid;
		setResponses({ ...responses });
	}, [grid]);

	// Delete property that is getting added from next question function.
	useEffect(() => {
		delete grid[data[(currentQuestion)].title];
	}, [currentQuestion]);

	// Set the fields and topics.
	let gridTopics = data[currentQuestion].topics;
	let gridFields = data[currentQuestion].answers;

	return (
		<>
			<main className="survey__panel question--grid">
				<p className="question__number">{t('survey.generic.Step')} {[currentQuestion + 1]}/{data.length}</p>
				<fieldset>
					<legend>{data[currentQuestion].title}</legend>
					<div className="question__question">
						<h1 className="question__label">{data[currentQuestion].title}</h1>
						<div className="question__instructions">
							<div className="markdown">
								<Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{data[currentQuestion].instruction}</Markdown>
							</div>
						</div>
						<div className="question__error-wrapper">
							<div id={'q' + [currentQuestion + 1] + 'error'} className="question__error" role="alert" aria-atomic="true"></div>
							<p id={'q' + [currentQuestion + 1] + 'error-content'} className="question__error-content">{t('survey.phrases.attention')}</p>
						</div>
						<div className="question__input">
							<div className="grid-header">
								<div></div>
								<div className="grid-choices">
									{gridFields.map(function (choice) {
										return (
											<div className="grid-choice"><div>{choice}</div></div>
										);
									})}
								</div>
							</div>
							{
								gridTopics.map((fields, i) => {
									let a = 0;
									let gridFieldName = data[currentQuestion].key + ' - ' + fields.key;
									// If the key isn't set for any reason fallback to the title
									if (data[currentQuestion].key == undefined) {
										gridFieldName = data[currentQuestion].title + ' - ' + fields.key;
									}
									return (
										<>
											<div key={fields.label} className="grid-item">
												<div className="grid-name">
													<div>{fields.label}</div>
													{(fields.required) ? <div className="grid-required" id={gridFieldName.toLowerCase().replace(/\s/g, '-').replace(/\W/g, '-') + 'error'}>{t('survey.generic.Required')}</div> : ''}
												</div>
												<div className="grid-choices">
													{gridFields.map(function (choice) {
														return (
															<div className="grid-choice">
																<label className='grid-choice__label'>
																	<span>{choice}</span>
																	<input
																		type='radio'
																		value={choice}
																		onChange={(event) => { gridHandler(event); }}
																		checked={(grid[gridFieldName] === choice) ? 'checked' : ''}
																		name={gridFieldName}
																		className={(fields.required) ? 'req' : ''}
																	/>
																</label>
															</div>
														);
													})}
												</div>
											</div>
										</>
									);
								})
							}
						</div>
					</div>
				</fieldset>
			</main>
		</>
	);
}
